module.exports = __webpack_public_path__ + "static/media/Ruta_Pickup_Wide.bbff88b4.png";